<template>
	<div class="eia-progress-bar">
		<div class="eia-progress-bar__progress"
			:style="style">
			<span>{{ Math.floor( this.progressPercentage, 1 ) }}%</span>
		</div>
	</div>
</template>

<script>
import { getPercentage } from '@/utils/math-utils';

export default {
	name: 'eia-progress-bar',
	props: {
		min: {
			type: Number,
			default: 0,
		},
		max: {
			type: Number,
			default: 100,
		},
		value: {
			type: Number,
			default: 0,
		},
	},

	computed: {
		progressPercentage() {
			if( typeof this.min === 'number' && typeof this.max === 'number' ) {
				return getPercentage( this.min, this.max, this.value );
			}

			return this.value;
		},

		style() {
			return {
				width: `${Math.max( this.progressPercentage, 1 )}%`,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-progress-bar {
	width: 100%;
	height: 40px;
	background: $color-grey-light;
	border-radius: $radius-full;
	overflow: hidden;

	&__progress {
		@include bg-gradient;
		width: 100%;
		height: 100%;
		border-radius: $radius-full;
		box-shadow: 2px 0 2px rgba( black, 0.05 );
		transition: width 250ms ease;
		text-align: center;
		line-height: 40px;
		font-weight: bold;

		span {
			padding: 0 20px;
		}
	}
}
</style>
